import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ContentWithCardLoading } from "../../../components/loading";
import AdvanceDataTable from "../../../components/normal-table/advance-table";
import ContentWrapper from "../../Wrapper";
import WalletHistorySubheader from "../components/wallet-history-subheader";
import * as GlobalTransactionsActions from "../store/actions/global_transactions_actions";

export default function WalletSummary(props) {
    const tabName = "Global Summary";
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10)

    const dispatch = useDispatch();

    const globalTransactionsSummaryStore = useSelector(store => store.walletHistory.global.summary);

    useEffect(() => {
        dispatch(GlobalTransactionsActions.getGlobalTransactionSummaryRequest({ page: page, limit: limit }))
    }, [dispatch, page, limit])

    console.log(globalTransactionsSummaryStore, "globalTransactionsSummaryStore")
    return <ContentWrapper subHeader={<WalletHistorySubheader tabName={tabName} />}>
        {globalTransactionsSummaryStore.loading ? (
            <ContentWithCardLoading />
        ) : globalTransactionsSummaryStore.data.length === 0 ? (
            "No data"
        ) : (
            <div className={`card card-custom`}>
                <div className="card-body py-3 px-3" style={{ padding: 15 }}>
                    <AdvanceDataTable
                        columns={[
                            { title: "AccountId", apiKeyName: "accountId", fieldInputType: "INPUT" },
                            { title: "Source", apiKeyName: "source", fieldInputType: "INPUT" },
                            { title: "Channel", apiKeyName: "channel", fieldInputType: "INPUT" },
                            { title: "Mode", apiKeyName: "mode", fieldInputType: "INPUT" },
                            { title: "Day", apiKeyName: "day", fieldInputType: "INPUT" },
                            { title: "Credit Balance", apiKeyName: "creditBalance", fieldInputType: "INPUT" },
                            { title: "Debit Balance", apiKeyName: "debitBalance", fieldInputType: "INPUT" },
                            { title: "Time", apiKeyName: "createdAt", fieldInputType: "DATE_TIME" }
                        ]}
                        data={globalTransactionsSummaryStore.data}
                        limit={limit}
                        pageNo={page}
                        setLimit={setLimit}
                        setPageNo={setPage}
                        count={globalTransactionsSummaryStore.count}
                    />
                </div>
            </div>
        )}
    </ContentWrapper>
}